import { render } from "./PageAds.vue?vue&type=template&id=25f31037"
const script = {}

import "./PageAds.vue?vue&type=style&index=0&id=25f31037&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__